import {Text, TextTypography} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {classes} from './no-events-text.st.css'

export const NoEventsText = props => <Text typography={TextTypography.smallTitle} {...props} className={classes.root} />
